/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { SprayDryer } from "./modelSprayDryer";

class ControllerSprayDryer extends ControllerModel {
  constructor() {
    super("ControllerSprayDryer");

    this.setNewNode = (callback) => {
      let sprayDryer = new SprayDryer();
      sprayDryer.decorate(callback);

      this.addNode(sprayDryer);
      SingletonFlowchart.SaveStatus();
    };

    this.loadNode = (node, callback) => {
      let sprayDryer = new SprayDryer();
      sprayDryer.copyFrom(node);
      sprayDryer.decorate(callback);
      this.addNode(sprayDryer);
    };

    this.getProperties = async (node) => {
      let n = new SprayDryer();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new SprayDryer();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerSprayDryer };
